import { createCell } from "./createCell"

export const createRowWithColSize = (cols: number, cellType = "td") => {
    let row = {
        type: 'tr',
        attrs: {},
        children: [],
    }

    let col = new Array(cols).fill(0).map((child) => createCell(cellType))
    row.children = col.slice()
    return Object.assign({}, row)
}
